export const FilterTypes = {
  MULTI_FILTER: 'multiFilter',
  SINGLE_FILTER: 'singleFilter',
  DATE_RANGE: 'dateRange',
};
